import { render, staticRenderFns } from "./SwiperPrev.vue?vue&type=template&id=367baf86&"
import script from "./SwiperPrev.vue?vue&type=script&lang=ts&"
export * from "./SwiperPrev.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports